<div class="container" mat-dialog-content>

<pre>{{data}}</pre>

</div>

<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</div>